import { Category, EntityTypes, JobOrder, ToManyRef } from "@bullhorn/bullhorn-types";
import { AppBridge, AppBridgeService, Helpers, IDataTableFilter, RemoteDataTableService } from "novo-elements";
import { Observable, from, of } from "rxjs";
import { Where } from '@bullhorn/taurus';
import { HttpService } from "./httpSubmissionsCard.service";
import { ActivatedRoute } from "@angular/router";

export class SubmissionCardRemoteDataTableService extends RemoteDataTableService<JobOrder> {
  public url: string;
  public additionalFilters: any = {};
  public jobCategories: Category[] = [];
  public candidateIds: number[] = [];

  constructor(private httpService: HttpService, private route: ActivatedRoute) {
    super();
  }

  public getTableResults(
    sort: { id: string; value: string; transform?: Function },
    filter: IDataTableFilter | IDataTableFilter[],
    page: number,
    pageSize: number,
    globalSearch?: string,
  ): Observable<{ results: JobOrder[]; total: number }> {
    const whereQuery: string = this.buildWhereClause(filter);
    const sortQuery: string = this.buildSortColumn(sort);
    const pageQuery: number = this.buildStart(page, pageSize);
    return from(this.getData(whereQuery, pageSize, sortQuery, pageQuery, filter));
    
  }

  private async getData(whereQuery, pageSize, sortQuery, pageQuery, filter): Promise<{ results: JobOrder[]; total: number }> {

    this.additionalFilters = { 'candidate.id': this.route.snapshot.queryParamMap.get('EntityID'), isDeleted: false, ...this.additionalFilters };
    whereQuery = this.buildWhereClause(filter);
    const submissionFields = 'id,dateAdded,dateLastModified,candidate(id,firstName,lastName,email,source,address,isAnonymized,occupation),status,sendingUser(name),source,jobOrder(id,title,owner,employmentType,startDate,dateEnd,clientContact(id,firstName,lastName,email,address),clientCorporation(id,name)),appointments(id,parentAppointment(id,subject,location)),latestAppointment(id,subject,location),payRate,billRate,salary,customText1,customText2,customText3,customText4,customText5,customText6,customText7,customText8,customText9,customText10,customText11,customText12,customText13,customText14,customText15,customText16,customText17,customText18,customText19,customText20,customText21,customText22,customText23,customText24,customText25,customDate1,customDate2,customDate3,customDate4,customDate5,customFloat1,customFloat2,customFloat3,customFloat4,customFloat5,customInt1,customInt2,customInt3,customInt4,customInt5,customTextBlock1,customTextBlock2,customTextBlock3,customTextBlock4,customTextBlock5,startDate,endDate';
    const response = await this.httpService.search(EntityTypes.JobSubmission, whereQuery, submissionFields, 'full', pageSize, sortQuery, pageQuery);

    const data = response?.data.map((submission) => {
      return {
        ...submission,
        candidate: submission.candidate,
        jobOrder: submission.jobOrder,
        sendingUser: submission.sendingUser,
        clientContact: submission.jobOrder.clientContact,
        clientCorporation: submission.jobOrder.clientCorporation
      }
    });
    return { results: data, total: response.total  };
  }

  private buildWhereClause(filter: IDataTableFilter | IDataTableFilter[]): string {
    const query: any = {};
    if (filter) {
      const filters = Helpers.convertToArray(filter);
      filters.forEach((aFilter) => {
        if(aFilter.id === 'clientCorporation') {
          query['jobOrder.clientCorporation'] = aFilter.transform(aFilter.value);
        } else {
          query[aFilter.id] = aFilter.transform ? aFilter.transform(aFilter.value) : aFilter.value;
        }
      });
    }

    console.log(this.additionalFilters);
    return (
      {
        status: {not: 'Archive'}, 
        ...query, 
         ...this.additionalFilters
      });
  }

  private buildSortColumn(sort: { id: string; value: string; transform?: Function }): string {
    if (sort) {
      let value = sort.id;
      if (sort.transform) {
        value = sort.transform(value);
      }
      return sort.value === 'asc' ? value : `-${value}`;
    }
    return '-status';
  }

  private buildStart(page: number, pageSize: number): number {
    return (page || 0) * pageSize;
  }

}